"use strict";
// packages/types/src/organisation.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionStatus = void 0;
var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["ACTIVE"] = "ACTIVE";
    SubscriptionStatus["PAST_DUE"] = "PAST_DUE";
    SubscriptionStatus["CANCELED"] = "CANCELED";
    SubscriptionStatus["TRIALING"] = "TRIALING";
    SubscriptionStatus["INACTIVE"] = "INACTIVE";
})(SubscriptionStatus || (exports.SubscriptionStatus = SubscriptionStatus = {}));
